import { BaseEntity, JsonApiResource } from '../jsonapi-provider';

@JsonApiResource({
  type: 'valid-code',
})
export default class ValidCode extends BaseEntity {
  controlInfo: string = '';
  description: string = '';
}
